// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2K25v","controls":"styles_controls__DI3AJ","charLimit":"styles_charLimit__3kOnR","input":"styles_input__2pZDY","send":"styles_send__yfTjJ"};